import { ActionTree } from 'vuex';
import { StateInterface } from '@/interfaces/projects';
import { FileDetails } from '@/interfaces/files';


const actions: ActionTree<FileDetails, StateInterface> = {
    setFileId(state, fileId) {
        state.commit("setFileId",fileId);
    },
    setNombre(state, nombre) {
        state.commit("setNombre",nombre);
    },
    setClasificacion(state, clasificacion) {
        state.commit("setClasificacion",clasificacion); 
    },
    setResultado(state, resultado) {
        state.commit("setResultado",resultado); 
    },
    setRevision(state, revision) {
        state.commit("setRevision",revision);
    },
    setLC(state, LC) {
        state.commit("setLC",LC);
    },
    setEstado(state, estado) {
        state.commit("setEstado",estado);
    },
    setRevisado(state, revisado) {
        state.commit("setRevisado",revisado);
    },
    setTxt(state, txt) {
        state.commit("setTxt",txt);
    },
    setDeletedFile(state, deletedFile) {
        state.commit("setDeletedFile",deletedFile);
    },
    setReload(state, reload) {
        state.commit("setReload",reload);
    },
    setDocuments(state, documents) {
        state.commit("setDocuments",documents);
    },
    setReloadFileList(state, boolean) {
        state.commit('setReloadFileList', boolean);
    },
    setMovingFile(state, movingFile) {
        state.commit("setMovingFile", movingFile);
    },
    setStartTime(state, startTime) {
        state.commit("setStartTime", startTime);
    },
    setDetectedErrors(state, detectedErrors) {
        state.commit("setDetectedErrors", detectedErrors);
    },
    setCurrentFile(state, payload) {
        state.commit("setFileId", payload.fileId);
        state.commit("setNombre", payload.nombre);
        state.commit("setClasificacion", payload.clasificacion); 
        state.commit("setResultado", payload.resultado); 
        state.commit("setRevision", payload.revision);
        state.commit("setRevisado", payload.revisado);
        state.commit("setEstado", payload.estado);

        state.commit("setStartTime", new Date().getTime());
        state.commit("setDetectedErrors", 0);
    },
    async resetFileDetails(state) {
        const baseFileDetails = {
            fileId: 0,
            nombre: "",
            clasificacion: 0,
            resultado: "",
            revision: "",
            LC: "",
            estado: 0,
            revisado: 0,
            deletedFile: false,
            txt: "",
            reload: false
        };
        state.commit('setFileId', baseFileDetails.fileId);
        state.commit('setNombre', baseFileDetails.nombre);
        state.commit('setClasificacion', baseFileDetails.clasificacion);
        state.commit('setResultado', baseFileDetails.resultado);
        state.commit('setRevision', baseFileDetails.revision);
        state.commit('setLC', baseFileDetails.LC);
        state.commit('setEstado', baseFileDetails.estado);
        state.commit('setRevisado', baseFileDetails.revisado);
        state.commit('setTxt', baseFileDetails.deletedFile);
        state.commit('setDeletedFile', baseFileDetails.txt);
        state.commit('setReload', baseFileDetails.reload);
    },
    setPaginationData(state, paginationData) {
        state.commit("setPaginationData", paginationData);
    },

}



export default actions;